import React from "react";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";
import TotalRow from "./TotalRow";
import "./DataTable.css";

const DataTable = ({
  isAdmin,
  tableData,
  intervals,
  totals,
  sortBy,
  sortOrder,
  handleSort,
  renderSortArrow,
  renderFilterButton,
  showDaily,
}) => {
  if (!tableData || tableData.length === 0) {
    return <div className="table">Нет данных для отображения</div>;
  }

  return (
    <table className="table">
      <thead className="table-header">
        <tr className="table-header-row">
          <TableHeader
            column="ink"
            label="ИНК"
            sortBy={sortBy}
            sortOrder={sortOrder}
            handleSort={handleSort}
            renderSortArrow={renderSortArrow}
            renderFilterButton={renderFilterButton}
          />
          <TableHeader
            column="company"
            label="Компания"
            sortBy={sortBy}
            sortOrder={sortOrder}
            handleSort={handleSort}
            renderSortArrow={renderSortArrow}
            renderFilterButton={renderFilterButton}
          />
          <TableHeader
            column="vacancy"
            label="Вакансия"
            sortBy={sortBy}
            sortOrder={sortOrder}
            handleSort={handleSort}
            renderSortArrow={renderSortArrow}
            renderFilterButton={renderFilterButton}
          />

          <TableHeader
            column="manager"
            label="Менеджер"
            sortBy={sortBy}
            sortOrder={sortOrder}
            handleSort={handleSort}
            renderSortArrow={renderSortArrow}
            renderFilterButton={renderFilterButton}
          />

          {intervals?.map((interval, index) => (
            <th
              key={index}
              style={{ fontSize: showDaily ? "0.8em" : "0.9em" }}
              title={
                showDaily ? `День: ${interval.label}` : `Неделя ${index + 1}`
              }
            >
              {interval.label}
            </th>
          ))}

          <TableHeader
            column="responds"
            label="Всего"
            sortBy={sortBy}
            sortOrder={sortOrder}
            handleSort={handleSort}
            renderSortArrow={renderSortArrow}
          />
        </tr>
      </thead>
      <tbody>
        {tableData.map((item, index) => (
          <TableRow
            key={index}
            item={item}
            intervals={intervals}
            showDaily={showDaily}
            isAdmin={isAdmin}
          />
        ))}
        {totals && (
          <TotalRow
            totals={totals}
            intervals={intervals}
            showDaily={showDaily}
            isAdmin={isAdmin}
          />
        )}
      </tbody>
    </table>
  );
};

export default DataTable;
